module.exports = __webpack_public_path__ + "img/weixin.8f6c0015.png";